<div *ngIf="saving" class="alert alert-success fade show saving text-center" role="alert">
  <span>{{message}}</span>
</div>
